/**
 * LoginApi - Authenticates user via backend Auth0 integration
 * Calls /verascore/login endpoint which handles Auth0 Resource Owner Password flow
 */

import PostApi from "./PostApi";
import { ProfileApiResponse } from "./Types";

const API_BASE = import.meta.env.VITE_API_URL || '/api';

function LoginApi(
  email: string,
  password: string,
  onSuccess: (data: ProfileApiResponse) => void,
  onFail: (data: any) => void,
  onReject: (response: string) => void
) {
  const payload = {
    username: email,
    password: password,
  };
  return PostApi<ProfileApiResponse>(
    `${API_BASE}/verascore/login`,
    payload,
    onSuccess,
    onFail,
    onReject
  );
}

export default LoginApi;

